import React from 'react'
import { Form } from 'semantic-ui-react'

export default function TextArea(props) {
  const { fluid, ...restProps } = props
  return (
    <Form.TextArea
      label={restProps.label}
      placeholder={restProps.placeholder || restProps.label}
      disabled={restProps.disabled}
      error={restProps.error}
      value={restProps.value || ''}
      onChange={(_, { value }) => restProps.onChange(value)}
      style={{ width: '100%', ...restProps.style }}
      rows={restProps.rows}
    />
  )
}

TextArea.defaultProps = {
  label: 'Notas',
  placeholder: null,
  disabled: false,
  loading: false,
  transparent: false,
  error: false,
  value: null,
  onChange: () => { },
}
